import React from 'react';
import { VideoPlayer } from '../components/VideoPlayer';
import { downloads } from '../data';

const liveCover = '/harlan-live-color.png';
const epkVideo = '/harlan-bw.mp4';

export function EpkPage() {
  return (
    <section className="panel inner-page">
      <div className="panel-header">
        <p className="eyebrow">EPK</p>
        <h2>Assets for buyers & promoters</h2>
        <p className="lede">
          Everything you need to book Harlan: promo video, photos, logos, and a one-sheet with rates and production
          details.
        </p>
      </div>
      <div className="epk">
        <div className="card video-card">
          <VideoPlayer className="epk-player" src={epkVideo} title="Harlan EPK Video" poster={liveCover} />
          <div className="media-meta">
            <p className="eyebrow">Promo Reel</p>
            <h3>Harlan EPK Video</h3>
            <p className="meta">Downloadable for offline review.</p>
            <a className="text-link" href={epkVideo} download>
              Download video →
            </a>
          </div>
        </div>
        <div className="card downloads">
          <div className="downloads-header">
            <h3>Downloads</h3>
            <p className="meta">Hi-res photos, logos, and one-sheet.</p>
          </div>
          <div className="download-grid">
            {downloads.map((item) => (
              <a key={item.label} className="download-pill" href={item.file} download>
                <span>{item.label}</span>
                <small>{item.description}</small>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
